import { render, staticRenderFns } from "./PatientTreatmentPlans.vue?vue&type=template&id=31f3c59f&"
import script from "./PatientTreatmentPlans.vue?vue&type=script&lang=js&"
export * from "./PatientTreatmentPlans.vue?vue&type=script&lang=js&"
import style0 from "./PatientTreatmentPlans.vue?vue&type=style&index=0&id=31f3c59f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports